export default __webpack_public_path__ + "static/love-164d034f45e0393633546bb5dfdaaf79.png";